/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react'
import { LinearProgress, styled } from '@mui/material'
import { DataGrid, GridRow, GridColumnHeaders, ptBR } from '@mui/x-data-grid'
import { CustomNoRowsOverlay } from './Customized'

const MemoizedRow = React.memo(GridRow)
const MemoizedColumnHeaders = React.memo(GridColumnHeaders)

const CustomDataGrid = styled(DataGrid)({
  border: 'none',
  '&.grid-list-root': {
    border: '1px solid #BDBDBD',
  },
  '.grid-list-virtual-scroller': {
    minHeight: 'fit-content',
  },
  '&.grid-list-root .grid-list-cell:focus-within': {
    outline: 'none !important',
  },
  '.grid-list-columnHeader:focus-within': {
    outline: 'none',
  },
  '.grid-list-columnHeader': {
    cursor: 'pointer',
  },
  '.grid-list-columnHeaders': {
    width: '100%',
  },
  '.grid-list-columnHeaderTitleContainerContent': {
    width: '100%',
    fontWeight: 'bold',
    wrapSpace: 'normal',
  },
  '.HiTheme-DataGrid-overlayWrapperInner, .HiTheme-DataGrid-overlayWrapper': {
    height: '473px',
  },
})

function Grid({ rows, columns, rowCount, slotProps, ...restDataGridProps }) {
  const [sortModel, setSortModel] = useState([{ field: 'isActive', sort: 'desc' }])

  const handleModelChange = (model) => {
    setSortModel(model)
  }

  const dataGrid = useMemo(() => {
    return {
      editable: false,
      columns,
      rows,
    }
  }, [rows, columns])

  return (
    <CustomDataGrid
      {...dataGrid}
      data-testid="data-grid"
      sortingOrder={['asc', 'desc']}
      sortModel={sortModel}
      onSortModelChange={handleModelChange}
      rowHeight={64}
      hideFooter
      hideFooterSelectedRowCount
      disableRowSelectionOnClick
      disableColumnMenu
      classes={{
        root: 'grid-list-root',
        cell: 'grid-list-cell',
        columnHeader: 'grid-list-columnHeader',
        columnHeaderTitleContainer: 'grid-list-columnHeaderTitleContainerContent',
        columnHeaders: 'grid-list-columnHeaders',
        virtualScroller: 'grid-list-virtual-scroller',
      }}
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
        row: MemoizedRow,
        columnHeaders: MemoizedColumnHeaders,
        loadingOverlay: LinearProgress,
      }}
      slotProps={slotProps}
      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      {...restDataGridProps}
    />
  )
}

export default Grid
